"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const common_1 = tslib_1.__importDefault(require("../assets/scripts/common"));
const dialog_zoom_vue_1 = tslib_1.__importDefault(require("./dialog-zoom.vue"));
const qrcode_1 = tslib_1.__importDefault(require("qrcode"));
const encode_1 = require("../assets/scripts/encode");
const __sfc_main = {};
__sfc_main.props = {
    actSign: {
        key: "actSign",
        required: true,
        type: String
    },
    clickable: {
        key: "clickable",
        required: true,
        type: Boolean
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { uid } = (0, common_1.default)();
    const props = __props;
    const dlZoom = (0, vue_demi_1.ref)();
    const data = {
        uid,
        actSign: props.actSign
    };
    const imgUrl = (0, vue_demi_1.ref)('');
    function showQRCode() {
        const secret = data.actSign; //拿活动标识当加密的secret
        const encodedData = encodeURIComponent((0, encode_1.encodeData)(JSON.stringify(data), secret));
        qrcode_1.default.toDataURL(encodedData).then((base64) => {
            imgUrl.value = base64;
        }).catch(err => {
            console.error(err);
        });
    }
    (0, vue_demi_1.onMounted)(() => {
        if (uid) {
            showQRCode();
        }
    });
    return {
        uid,
        props,
        dlZoom,
        imgUrl
    };
};
__sfc_main.components = Object.assign({
    DialogZoom: dialog_zoom_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXgudnVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaW5kZXgudnVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQW1CQSx1Q0FBMEM7QUFDMUMsOEVBQWlEO0FBQ2pELGdGQUEyQztBQUMzQyw0REFBNEI7QUFDNUIscURBQXNEO0FBQ3RELE1BQU0sVUFBVSxHQUFHLEVBQUUsQ0FBQztBQUN0QixVQUFVLENBQUMsS0FBSyxHQUFHO0lBQ2pCLE9BQU8sRUFBRTtRQUNQLEdBQUcsRUFBRSxTQUFTO1FBQ2QsUUFBUSxFQUFFLElBQUk7UUFDZCxJQUFJLEVBQUUsTUFBTTtLQUNiO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsR0FBRyxFQUFFLFdBQVc7UUFDaEIsUUFBUSxFQUFFLElBQUk7UUFDZCxJQUFJLEVBQUUsT0FBTztLQUNkO0NBQ0YsQ0FBQztBQUNGLFVBQVUsQ0FBQyxLQUFLLEdBQUcsQ0FBQyxPQUFPLEVBQUUsS0FBSyxFQUFFLEVBQUU7SUFDcEMsTUFBTSxFQUNKLEdBQUcsRUFDSixHQUFHLElBQUEsZ0JBQVMsR0FBRSxDQUFDO0lBQ2hCLE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQztJQUN0QixNQUFNLE1BQU0sR0FBRyxJQUFBLGNBQUcsR0FBbUMsQ0FBQztJQUN0RCxNQUFNLElBQUksR0FBRztRQUNYLEdBQUc7UUFDSCxPQUFPLEVBQUUsS0FBSyxDQUFDLE9BQU87S0FDdkIsQ0FBQztJQUNGLE1BQU0sTUFBTSxHQUFHLElBQUEsY0FBRyxFQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3ZCLFNBQVMsVUFBVTtRQUNqQixNQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsaUJBQWlCO1FBQzlDLE1BQU0sV0FBVyxHQUFHLGtCQUFrQixDQUFDLElBQUEsbUJBQVUsRUFBQyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUM7UUFDakYsZ0JBQU0sQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsTUFBYyxFQUFFLEVBQUU7WUFDcEQsTUFBTSxDQUFDLEtBQUssR0FBRyxNQUFNLENBQUM7UUFDeEIsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxFQUFFO1lBQ2IsT0FBTyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUNyQixDQUFDLENBQUMsQ0FBQztJQUNMLENBQUM7SUFDRCxJQUFBLG9CQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ2IsSUFBSSxHQUFHLEVBQUUsQ0FBQztZQUNSLFVBQVUsRUFBRSxDQUFDO1FBQ2YsQ0FBQztJQUNILENBQUMsQ0FBQyxDQUFDO0lBQ0gsT0FBTztRQUNMLEdBQUc7UUFDSCxLQUFLO1FBQ0wsTUFBTTtRQUNOLE1BQU07S0FDUCxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBQ0YsVUFBVSxDQUFDLFVBQVUsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDO0lBQ3BDLFVBQVUsRUFBVix5QkFBVTtDQUNYLEVBQUUsVUFBVSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0FBQzFCLGtCQUFlLFVBQVUsQ0FBQyJ9